module.exports = __webpack_public_path__ + "static/newStudy-5d415c0f718ed79b8b762b6b95188e1f.jpg";